import { mainLayoutLocators } from '@locators/main-layout';
import SoftPhoneModule from '@modules/SoftPhoneModule';
import usePhoneState from '@modules/SoftPhoneModule/usePhoneState';
import { FeatureFlagKeys, useFeatureFlags } from '@modules/FeatureFlagModule';

const CallStatePanel = () => {
  const phoneState = usePhoneState();
  const {
    [FeatureFlagKeys.featureRtcWebphoneHandlesFetchingJwt]:
      featureRtcWebphoneHandlesFetchingJwt,
  } = useFeatureFlags();

  const handleReconnect = () => {
    if (featureRtcWebphoneHandlesFetchingJwt) {
      // New behavior: MFE handles JWT fetching
      SoftPhoneModule.activateWebPhone();
    } else {
      // Old behavior: Frontend fetches JWT and reconnects
      SoftPhoneModule.reconnect();
    }
  };

  return (
    <div>
      <button
        id={mainLayoutLocators.navBar.disconnectButton}
        onClick={() => SoftPhoneModule.disconnectSoftPhone()}
        className='m-r-2'
      >
        Disconnect
      </button>
      <button
        disabled={phoneState.phoneConnected}
        id={mainLayoutLocators.navBar.reconnectButton}
        onClick={handleReconnect}
      >
        Reconnect
      </button>
      <pre>{JSON.stringify(phoneState, undefined, 2)}</pre>
    </div>
  );
};

export default CallStatePanel;
